// Product brand theme IDs and URL resolution (products section only).

export const PRODUCT_THEME_IDS = {
  SENSAPHONE: "sensaphone",
  TRACETEK: "tracetek",
  RAYCHEM: "raychem",
  PICOBOX: "picobox",
};

const PATH_THEME_RULES = [
  { segment: "/products/picobox", theme: PRODUCT_THEME_IDS.PICOBOX },
  { segment: "/products/raychem", theme: PRODUCT_THEME_IDS.RAYCHEM },
  { segment: "/products/tracetek", theme: PRODUCT_THEME_IDS.RAYCHEM },
  { segment: "/products/sensaphone", theme: PRODUCT_THEME_IDS.SENSAPHONE },
];

/**
 * Resolve product theme from pathname (e.g. /products/tracetek/alarm).
 */
export function resolveProductThemeFromPath(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return PRODUCT_THEME_IDS.SENSAPHONE;
  }
  const normalized = pathname.toLowerCase();
  for (const { segment, theme } of PATH_THEME_RULES) {
    if (normalized.includes(segment)) return theme;
  }
  return PRODUCT_THEME_IDS.SENSAPHONE;
}

/**
 * Resolve theme from brand name or URL when pathname is ambiguous.
 */
export function resolveProductThemeFromBrand(brand) {
  if (!brand) return PRODUCT_THEME_IDS.SENSAPHONE;
  const name = (brand.name || "").toLowerCase();
  const url = (brand.url || "").toLowerCase();
  if (name.includes("picobox") || url.includes("picobox")) {
    return PRODUCT_THEME_IDS.PICOBOX;
  }
  if (name.includes("raychem") || url.includes("raychem")) {
    return PRODUCT_THEME_IDS.RAYCHEM;
  }
  if (name.includes("tracetek") || url.includes("tracetek")) {
    return PRODUCT_THEME_IDS.RAYCHEM;
  }
  if (name.includes("sensaphone") || url.includes("sensaphone")) {
    return PRODUCT_THEME_IDS.SENSAPHONE;
  }
  return resolveProductThemeFromPath(url || "");
}
